var _path, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgQuestionTransparent(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 23,
    height: 23,
    viewBox: "0 0 23 23",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M11.4998 0C5.14868 0 0 5.14877 0 11.5C0 17.8516 5.14868 23 11.4998 23C17.8513 23 23 17.8516 23 11.5C23 5.14877 17.8513 0 11.4998 0ZM11.4998 21.5851C5.95151 21.5851 1.43748 17.0484 1.43748 11.5C1.43748 5.95156 5.95151 1.43746 11.4998 1.43746C17.0481 1.43746 21.5625 5.95159 21.5625 11.5C21.5625 17.0483 17.0481 21.5851 11.4998 21.5851ZM10.4429 17.9795H12.2512V16.1546H10.4429V17.9795ZM11.4786 5.02081C10.4257 5.02081 9.55816 5.30471 8.8768 5.87183C8.19543 6.43926 7.8641 7.5756 7.88099 8.51717L7.90758 8.56963H9.55708C9.55708 8.00793 9.74431 7.20077 10.1188 6.91112C10.4929 6.62182 10.9464 6.47699 11.479 6.47699C12.0928 6.47699 12.5646 6.64374 12.8956 6.97722C13.2263 7.31072 13.3912 7.78761 13.3912 8.40717C13.3912 8.92791 13.269 9.37245 13.0236 9.74081C12.7774 10.1092 12.3648 10.6357 11.7862 11.3203C11.1893 11.8586 10.8206 12.2913 10.6805 12.6187C10.54 12.9465 10.467 13.5344 10.4616 14.3822H12.1902C12.1902 13.8503 12.2239 13.4582 12.2912 13.2066C12.358 12.9554 12.5495 12.6716 12.8654 12.3556C13.5443 11.7009 14.0894 11.0605 14.5024 10.4341C14.9142 9.8084 15.1205 9.11804 15.1205 8.36335C15.1205 7.31038 14.8021 6.48993 14.1642 5.90235C13.5259 5.31441 12.6307 5.02081 11.4786 5.02081Z",
    fill: "url(#paint0_linear_636_2064)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_636_2064",
    x1: 23,
    y1: 9,
    x2: -8.4224e-9,
    y2: 9.5,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#8764FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#6E74FF"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgQuestionTransparent);
export default __webpack_public_path__ + "static/media/question_transparent.399d50e9b781845314502dff41f25eff.svg";
export { ForwardRef as ReactComponent };